import CloseIcon from '@mui/icons-material/Close';
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

type IDialogLoading = {
  isOpen: boolean;
  onClose: () => void;
};

export const DialogLoading: React.FC<IDialogLoading> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h6">
          Este processo pode demorar alguns minutos.
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ minWidth: 500, textAlign: 'center' }}>
        <Typography color="GrayText" mb={2}>
          Por favor, aguarde!
        </Typography>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  );
};

